export const dexieSchema={
  chatSessions: 'id,business,module,bot_team,project,created',
  chatMessages: 'id,conversation,sender_type,bot,created',
  chatSummaries: 'id,business,session,created',
  botConsultationLogs: 'id,business,message,lead_bot,consulted_bot,created',
  plans: 'id,business,source_plan,status,project,version,created',
  tasks: 'id,business,source_plan,status,project,due_date,created',
  files: 'id,business,tags,created',
  inboxMessages: 'id,business,triage_status,created',
  adCampaignBriefs: 'id,business,plan,status,project,created',
  businessMemory: 'id,business,module,extraction_method,created',
  agentFlows: 'id,business,bot,created',
  knowledgeSources: 'id,business,bot,source_type,ingested_status,created',
  llmProviderCredentials: 'id,provider,enabled,created',
  projects: 'id,business,name,status,created',
  // BB-3 (docs/build_bot_platform.md §3.3): client-side-only response cache —
  // content-addressed (tier + normalized messages hash), 24h TTL, consulted
  // only for identical re-sends. Server-side caching of model content is
  // FORBIDDEN under hybrid local-first; this table never leaves the browser.
  responseCache: 'key,created',
  // T4 (docs/local-search-architecture.md): MiniSearch serialized index blob.
  // Rehydrated on boot; rebuilt only on schema version bump / mismatch.
  search_index_blob: 'id,updated'
};

export const confidentialCollections=[
  'chatSessions',
  'chatMessages',
  'chatSummaries',
  'botConsultationLogs',
  'plans',
  'tasks',
  'files',
  'inboxMessages',
  'adCampaignBriefs',
  'businessMemory',
  'agentFlows',
  'knowledgeSources',
  'llmProviderCredentials',
  'projects',
  'responseCache',
  'search_index_blob'
];
